
import MiniMainCard from '../MiniMainCard';

const MainCard = ({ MainTitle, data, isGen4Device }) => {

    const rawRssi = data?.rssi?.value  // Assuming data.rssi contains the RSSI value
    // Number('') and Number(' ') are both 0, so reject blank strings before converting.
    const signalStrength = typeof rawRssi === 'string' && rawRssi.trim() !== '' ? Number(rawRssi) : rawRssi;

    // Gen4 reports a missing reading as the string '--', Gen2/Gen3 report it as undefined.
    // Treat both as "no reading" so the status badge stays hidden.
    const showStatus = typeof signalStrength === 'number' && Number.isFinite(signalStrength);

    let networkStatus = null;
    let bgColour = 'bg-placeholder';

    if (isGen4Device) {
        // Gen4 radios report on a wider scale (-30 dBm best, down to -140 dBm at the edge)
        if (signalStrength >= -60) {
            networkStatus = "Best";
            bgColour = 'bg-alertSuccess'
        } else if (signalStrength >= -90 && signalStrength < -60) {
            networkStatus = "Good";
            bgColour = 'bg-alertSuccess'
        } else if (signalStrength >= -120 && signalStrength < -90) {
            networkStatus = "Weak";
            bgColour = 'bg-alertWarning'
        } else {
            networkStatus = "Very Weak";
            bgColour = 'bg-alertError'
        }
    } else if (signalStrength >= -50) {
        networkStatus = "Excellent";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -60 && signalStrength < -50) {
        networkStatus = "Good";
        bgColour = 'bg-alertSuccess'
    } else if (signalStrength >= -70 && signalStrength < -60) {
        networkStatus = "Fair";
        bgColour = 'bg-alertWarning'
    } else if (signalStrength >= -80 && signalStrength < -70) {
        networkStatus = "Weak";
        bgColour = 'bg-alertError'
    } else {
        networkStatus = "Very Weak";
        bgColour = 'bg-alertError'
    }

    return (
        <div className=' w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] border-2 border-dividerLines bg-secondaryBg rounded-md'>
            {MainTitle ? (
                <>
                    <div className=' flex justify-between items-center'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        {showStatus && networkStatus ?
                            <div className={`text-labels text-center text-[10px] 2xl:text-[12px] font-semibold max-w-fit ${bgColour} px-2 py-0.5 rounded-xl`}>
                                <span>{networkStatus}</span>
                            </div>
                            :
                            <></>
                        }
                    </div>
                </>
            )
                : '--'
            }
            <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
            <MiniMainCard
                miniCardData={data}
            />
        </div >
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard